import React from "react";
import Icon from "./Icon";

export const DownloadRedIcon = () => (
  <Icon>
    <path fillRule="evenodd" clipRule="evenodd" d="M14.88 11.29L13 13.17V4.5C13 3.95 12.55 3.5 12 3.5C11.45 3.5 11 3.95 11 4.5V13.17L9.11 11.29C8.72 10.9 8.09 10.9 7.7 11.29C7.31 11.68 7.31 12.31 7.7 12.7L11.29 16.29C11.68 16.68 12.31 16.68 12.7 16.29L16.29 12.7C16.68 12.31 16.68 11.68 16.29 11.29C15.9 10.9 15.27 10.9 14.88 11.29ZM6 19.5C5.44772 19.5 5 19.9477 5 20.5C5 21.0523 5.44772 21.5 6 21.5H18C18.5523 21.5 19 21.0523 19 20.5C19 19.9477 18.5523 19.5 18 19.5H6Z" fill="#C1122A"/>
  </Icon>
);
